<template>
  <portal :to="useTopPortal ? 'iqos-modal-portal' : 'white-modal-portal'">
    <div class="modal-backdrop"></div>
    <div class="modal-wrapper qrw-box-shadow-16dp" :class="[size]">
      <div class="modal-header" v-if="title || subtitle">
        <div class="titles-container gap-row-zero w-100">
          <div class="qrw-heading-xs bold v1-grey-10-color">
            <slot name="title">
              {{ title }}
            </slot>
          </div>
          <div class="qrw-label-sm v1-grey-7-color" v-if="subtitle">
            <slot name="subtitle">
              {{ subtitle }}
            </slot>
          </div>
        </div>
        <BaseIconButton
          variant="ghost"
          @click="$emit('close')"
          size="md"
          icon="x"
          textColor="content-secondary"
        />
      </div>
      <div class="modal-scroll-container">
        <div :class="['modal-body', bodyClass]">
          <slot />
        </div>
      </div>

      <div class="modal-footer" v-if="!hideFooter">
        <slot name="footer" />
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    title: [String, Boolean],
    subtitle: {
      type: [String, Boolean],
      default: false,
    },
    bodyClass: String,
    useTopPortal: Boolean,
    size: {
      type: String,
      default: "md",
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style scoped>
.modal-header {
  background: var(--qrw-background-base-secondary);
  padding: 10px 10px 10px 24px;
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  box-sizing: border-box;
}

.titles-container {
  justify-content: center;
}

.modal-wrapper {
  border-radius: 8px;
  overflow: hidden;

  z-index: 15;
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
  background: var(--v1-grey-1-color);
}

.modal-wrapper.md {
  width: 1000px;
  min-width: 1000px;
}

.modal-wrapper.sm {
  width: 624px;
  min-width: 624px;
}

.modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  background: var(--qrw-background-base-primary);
  overflow-y: auto;
  max-height: calc(100vh * 0.6);
}

.modal-footer {
  background: var(--qrw-background-base-secondary);
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
}

.modal-scroll-container {
  overflow-y: auto;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;

  background: rgba(0, 0, 0, 0.24);

  width: 100vw;
  height: 100vh;
  z-index: 10;
}
</style>
